// extracted by mini-css-extract-plugin
module.exports = {"componentWrapper":"HorizontalList_componentWrapper__1ChXW"};